import { ReactNode } from 'react'

interface GoogleMapsLinkProps {
  address: string | null | undefined
  fallback?: ReactNode
  className?: string
}

/**
 * Renders an address as a clickable link to Google Maps search. Returns
 * `fallback` when the address is null / undefined / empty.
 */
export function GoogleMapsLink({
  address,
  fallback = 'N/A',
  className = 'text-brand-bright hover:text-brand-active transition-colors',
}: GoogleMapsLinkProps) {
  if (!address) return <>{fallback}</>

  return (
    <a
      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {address}
    </a>
  )
}
